import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import { ErrorSharp } from "@mui/icons-material";
import Cart, { generateCartItemsFrom, getTotalCartValue } from "./Cart";
import { WindowSharp } from "@mui/icons-material";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 *
 * @property {string} name - The name or title of the product


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

const Products = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [items, setItems] = useState([]);
  const [defaultCardDataArray, setDefaultCardDataArray] = useState([]);
  const [filteredCardArray, setFilteredCardArray] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [debounceTimeout, setDebounceTimeout] = useState(0);
  // const [searchString, setSearchString] = useState("");
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);

  // const updateSearchString = (event) => {
  //   setSearchString(event.target.value);
  // };

  useEffect(
    () => {
      const onHandler = async () => {
        console.log("use effect call");
        const token = window.localStorage.token;
        const productsData = await performAPICall();
        setProducts(productsData);

        // console.log("token value is:", token);
        if (window.localStorage.token) {
          // no need to put if condition(to check isloggedin) for fetchCart(because in fetchCart the condition is there if a person is logged in or not);
          // fetchCart returns the GET API Response for api/v1/Cart; we need to have something posted in /cart before accessing it.
          const cartData = await fetchCart(window.localStorage.token);
          setCart(cartData);
          //  generateCartItemsFrom returns full products details(for items in cart);
          const cartDetails = await generateCartItemsFrom(
            cartData,
            productsData
          );
          setItems(cartDetails);
          // console.log("cartDetails are:", cartDetails);
          const totalCost = getTotalCartValue(cartDetails);
        }
      };

      onHandler();

      // if(searchString.length===0){
      //   console.log("searchString is:",searchString);
      //   performAPICall();

      // }

      // else{
      //   console.log("searchString is:",searchString);
      //   performSearch(searchString);

      // }
    },
    [],
    
  );

  // useEffect(() => {
  //   setPageLoading(true);
  //   performSearch();
  // }, searchString,cardDataArray);

  // const updateSearchString=(event)=>{
  //   setSearchString(event.target.value);
  // }

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    console.log("performAPICall() called.....");
    setPageLoading(true);
    try {
      const response = await axios.get(`${config.endpoint}/products`);
      // console.log("performAPICall function", response.data); //response.dat=>array of objects.
      setPageLoading(false);
      setDefaultCardDataArray(response.data);
      setFilteredCardArray(response.data);
      return response.data;
    } catch (error) {
      setPageLoading(false);
      if (error.response) {
        enqueueSnackbar(error.response, {
          variant: "error",
        });
      } else {
        // Something went wrong.Check that the backend is running, reachable and returns valid json
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    // const newSearchURL=`${config.endpoint}/products`;
    // if(searchString.length>0){
    //   try{
    //   const searchResponse=await axios.get(`${config.endpoint}/products/search?value=${searchString}`);
    //   setPageLoading(false);
    //   setCardDataArray(searchResponse.data);
    //   }catch(error){
    //     console.log("Search Error is",error.message);
    //     setPageLoading(false);

    //   }
    // }

    // else{
    //     performAPICall();
    // }
    setPageLoading(true);

    try {
      const searchResponse = await axios.get(
        `${config.endpoint}/products/search?value=${text}`
      );

      setPageLoading(false);
      setFilteredCardArray(searchResponse.data);
      return searchResponse.data;
    } catch (error) {
      setPageLoading(false);
      if (error.response) {
        if (error.response.status === 404) {
          enqueueSnackbar("No products found", { variant: "error" });
          setFilteredCardArray([]);
        }
        if (error.response.status === 500) {
          enqueueSnackbar(error.response.data.message, { variant: "error" });
          setFilteredCardArray(defaultCardDataArray);
        }
      } else {
        enqueueSnackbar(
          "Could not fetch products.Check that the backend is running, reachable and returns valid JSON response.",
          {
            variant: "error",
          }
        );
      }
    }
  };

  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */

  const fetchCart = async (token) => {
    console.log("Great! FetchCart() REACHED!");
    console.log("fecthCart() token is:", token);
    if (!token) return;

    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data

      // await axios.post("http://43.205.22.100:8082/api/v1/cart",{"productId":"KCRwjF7lN97HnEaY","qty":4},{ headers : {Authorization : `Bearer ${token}`}} );
      const cartAPIResponse = await axios.get(`${config.endpoint}/cart`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // cartAPIResponse.data is Array of object......[ {product id:"" , qty:""}  ];
      console.log("CART API response is : ", cartAPIResponse.data);
      return cartAPIResponse.data;
      // const cartData=cartAPIResponse.data;

      // return generateCartItemsFrom(cartData,defaultCardDataArray);

      // Below is the syntax of POST API for CART.
      // axios.post("http://3.111.115.63:8082/api/v1/cart",{"productId":"BW0jAAeDJmlZCF8i","qty":1},{ headers : {Authorization : `Bearer ${token}`}} );
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
    const value = event.target.value;
    // console.log("value is:", value);
    if (debounceTimeout !== 0) {
      clearTimeout(debounceTimeout);
    }

    const timeout = setTimeout(() => {
      performSearch(value);
    }, 500);

    setDebounceTimeout(timeout);
  };

  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    // console.log("isItemCart items ", items);
    // console.log("isItemCart productId ", productId);
    let output = false;
    items.forEach((item) => {
      if (item._id === productId) {
        output = true;
      }
    });

    return output;
  };

  // const addItemToCart = async (productId, qty) => {

  // console.log("addITEMToCart Reached....");

  // };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  // const addToCart = async (
  //   token,
  //   items,
  //   products,
  //   productId,
  //   qty,
  //   options = { preventDuplicate: false }
  // ) => {
  //   // console.log("addToCart called.....");
  //   // console.log("addToCart Token: ", token);
  //   // console.log("addToCart items: ", items);
  //   // console.log("addToCart products: ", products);
  //   // console.log("addToCart productId: ", productId);
  //   // console.log("addToCart qty: ", qty);
  //   // console.log("addToCart options: ", options.preventDuplicate);

  //   let exists = isItemInCart(items, productId);
  //   // console.log("Clicked button product is available: ", exists);
  //   const header = {
  //     headers: {
  //       "Authorization": `Bearer ${window.localStorage.getItem("token")}`,
  //       "Content-type": "application/json"
  //     },
  //   };

  //   const bodyParameters = {
  //     "productId": productId,
  //     "qty" : qty
  //   };

  //   //  checking if logged in
  //   if (window.localStorage.getItem("token")!==null) {
     
  //     // preventDuplicate to check if adding from AddToCart button or +/-.....below is AddToCart Button
  //     if(options.preventDuplicate){

  //       if (exists===true && options.preventDuplicate) 
  //       {
  //         enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.",{variant:"warning"});
  //       } 
  //       else 
  //       {
  //         try {
  //           console.log("post CArt url :", config.endpoint + "/cart");
  //           const response = await axios.post(
  //             `${config.endpoint}/cart`,
  //             bodyParameters,
  //             header
  //           );
  //           console.log("addToCart response", response);
  //           const cartData = await fetchCart(window.localStorage.token);
  //           setCart(cartData);
  //           //  generateCartItemsFrom returns full products details(for items in cart);
  //           const cartDetails = await generateCartItemsFrom(
  //             cartData,
  //             products
  //           );
  //           setItems(cartDetails);  




  //         } catch (error) { enqueueSnackbar("POST API Error",{variant:"warning"});}
  //       }

  //     }

  //     // else if just for products already in cart.....for +/-
  //     else{


  //       try {
  //         console.log("post CArt url :", config.endpoint + "/cart");
  //         const response = await axios.post(
  //           `${config.endpoint}/cart`,
  //           bodyParameters,
  //           header
  //         );
  //         console.log("addToCart response", response);
  //           const cartData = await fetchCart(window.localStorage.token);
  //           setCart(cartData);
  //           //  generateCartItemsFrom returns full products details(for items in cart);
  //           const cartDetails = await generateCartItemsFrom(
  //             cartData,
  //             products
  //           );
  //           setItems(cartDetails);  

  //       } catch (error) {enqueueSnackbar("POST API Error",{variant:"warning"});}


  //     }


      
  //   } 
    
  //   else if(window.localStorage.getItem("token")===null && options.preventDuplicate){
  //     enqueueSnackbar("Login to add an item to the Cart",{variant : "warning"});
  //     // console.log("not logged innnnn");

  //   }



  // };
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    check = { preventDuplicate: false }
  ) => {
    if (!token) {
      enqueueSnackbar("Login to add an item to the Cart", {
        variant: "warning",
      });
      return;
    }
    if (check.preventDuplicate && isItemInCart(items, productId)) {
      enqueueSnackbar(
        "Item already in Cart.Use the cart sidebar to update quantity or remove item",
        { variant: "warning" }
      );
      return;
    }

    try {
      const url = `${config.endpoint}/cart`;
      const response = await axios.post(
        url,
        { productId, qty },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const cartItems = generateCartItemsFrom(response.data, products);
      setItems(cartItems);
    } catch (error) {
      if (error.response) {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
        return null;
      } else {
        enqueueSnackbar(
          "Could not fetch products. Check that the backend is running, reachable and returns valid JSON",
          { variant: "error" }
        );
      }
    }
  };
  return (
    <div>
      {/* <Header>
        this was given by default
      </Header> */}

      {/* BELOW IS MY PREVIOUS HEADER */}
      <Header
        hasHiddenAuthButtons={window.localStorage.length}
        children="products"
        // searchString={searchString}
        // setSearchString={setSearchString}
      />

      {/* <Header> */}
      {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}

      {/* </Header> */}

      <TextField
        className="search-desktop"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        // value={searchString}
        // onChange={updateSearchString}
        onChange={(e) => debounceSearch(e, debounceTimeout)}
      />

      {/* dont forget to change className='search-desktop' */}
      {/* Search view for mobiles  */}
      {/* <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        // value={searchString}
        // onChange={updateSearchString}
        onChange={(e) => debounceSearch(e, debounceTimeout)}
      /> */}

      {window.localStorage.length > 0 && (
        <Grid container spacing={1}>
          {/* Below grid element added by me in module-4 */}
          <Grid item xs={12} md={9}>
            <Grid item className="product-grid">
              <Box className="hero">
                <p className="hero-heading">
                  India’s{" "}
                  <span className="hero-highlight">FASTEST DELIVERY</span> to
                  your door step
                </p>
              </Box>
            </Grid>
            {/* below 2 grids are added by me in module-4 */}
            <Grid item xs={12} md={12}>
              <Grid container spacing={0.5}>
                {!pageLoading &&
                  filteredCardArray.map((cardObject) => {
                    return (
                      <Grid item xs={6} md={3} key={cardObject._id}>
                        {/* <ProductCard product={cardObject} key={cardObject._id} /> */}
                        {/* addToCart(token={token},items={cart},products={products}) */}
                        <ProductCard
                          product={cardObject}
                          key={cardObject._id}
                          handleAddToCart={async () => {
                            await addToCart(
                              window.localStorage.getItem("token"),
                              items,
                              products,
                              cardObject._id,
                              1,
                              { preventDuplicate: true }
                            );
                          }}
                        />
                      </Grid>
                    );
                  })}
                {pageLoading && (
                  <Grid item className="product-grid">
                    <Box className="loading">
                      <CircularProgress />
                      Loading Products...
                    </Box>
                  </Grid>
                )}
                {/* Below 2 grids are added by me in module-4 */}
              </Grid>
            </Grid>
          </Grid>
          {/* Below grid element also added by me in module-4 */}
          <Grid className="CartColor" item xs={12} md={3}>
            <Cart
              products={products}
              items={items}
              handleQuantity={addToCart}
            />
          </Grid>
        </Grid>
      )}

      {window.localStorage.getItem("token")===null && (
        <Grid container spacing={1}>
          {/* Below grid element added by me in module-4 */}

          <Grid item className="product-grid">
            <Box className="hero">
              <p className="hero-heading">
                India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
                to your door step
              </p>
            </Box>
          </Grid>

          {!pageLoading &&
            filteredCardArray.map((cardObject) => {
              return (
                <Grid item xs={6} md={3} key={cardObject._id}>
                  {/* <ProductCard product={cardObject} key={cardObject._id} /> */}
                  <ProductCard
                    product={cardObject}
                    key={cardObject._id}
                    handleAddtoCart={async () => {
                      await addToCart(
                        window.localStorage.getItem("token"),
                        items,
                        products,
                        cardObject._id,
                        1,
                        { preventDuplicate: true }
                      );
                    }}
                  />
                  
                </Grid>
              );
            })}
          {pageLoading && (
            <Grid item className="product-grid">
              <Box className="loading">
                <CircularProgress />
                Loading Products...
              </Box>
            </Grid>
          )}
        </Grid>
      )}

      {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}
      <Footer />
    </div>
  );
};

export default Products;
